import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ThemeSwitchService } from './theme-switch.service';
import { ThemeSwitcherComponent } from './components';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [ThemeSwitcherComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FrontendIconsModule,
    IonicModule,
  ],
  exports: [ThemeSwitcherComponent],
})
export class ThemeSwitchModule { }
